export default __webpack_public_path__ + "static/media/aa949ae7e572843878e88a1c00b63333.svg";